import { SelectField } from '../../../../types/general';

export const priceOptions: SelectField[] = [
  { label: 'CPM', value: 'cpm' },
  { label: 'CPC', value: 'cpc' },
  { label: 'CPA', value: 'cpa' },
];
